<template>
  <div class="vote-view-container">
    <div class="vote-start-message-container-wrapper">
      <div class="vote-start-message-container">
        It's time to vote!
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue';

export default Vue.extend({
  name: 'VoteView'
})
</script>

<style scoped lang="scss">
.vote-start-message-container-wrapper {
  flex: 1;
  display: flex;
  justify-content: center;
  align-items: center;
}

.vote-start-message-container {
  font-size: 2em;
  border-radius: 0.4em;
  padding: 0.6em 1.2em;
  color: $natural-white;
  background-color: $brand-teal;
}
</style>
